import { ICPlatformVersion } from './versions.constants'

/**
 * Maps a platform version to its human-facing release label: `R<month>`, with
 * the year dropped.
 *
 *   r2026_09_0 -> "R9"   (month segment 09 -> 9)
 *   r2026_10_0 -> "R10"
 *   r2025_02_1 -> "R2"   (patch suffix ignored)
 *
 * Returns an empty string when the version cannot be resolved to a name.
 */
export const formatICPlatformReleaseLabel = (version: ICPlatformVersion): string => {
  const name = ICPlatformVersion[version]
  const monthSegment = name?.split('_')[1]
  const month = monthSegment ? parseInt(monthSegment, 10) : NaN
  return Number.isNaN(month) ? '' : `R${month}`
}
